import React, {useEffect, useState, useCallback} from "react";
import Typography from "@material-ui/core/Typography";
import clsx from 'clsx';
import {useFeatureItemStyle} from "../styles/FeatureItemStyle";
import AppColors from "../colors/AppColors";
import {blueGrey} from "@material-ui/core/colors";
import {IconButton} from "@material-ui/core";
import {NumberUtils} from '../utils/NumberUtils';
import {InlineIcon} from "@iconify/react";
import {useDispatch} from 'react-redux';
import {Constants} from "../constants/Constants";
import CryptoUtils from "../utils/CryptoUtils";

export default function OperationTimer(props: any) {

    const classes = useFeatureItemStyle();
    const initialCount = parseFloat(props.count);
    let [count, setCount] = useState(initialCount);
    const canDispatch = props.canDispatch;
    const description = props.description;
    const step: number = props.step ? parseFloat(props.step) : 1;
    const target: number = parseFloat(props.target);
    const external: boolean = props.external;
    const randomTimeInMills = () => Math.random() * 5_000;
    const dispatch = useDispatch();

    const incrementUsersCount = useCallback((value: number) => {
        if (canDispatch) {
            dispatch({type: Constants.REGISTERED_USERS_COUNT, payload: value})
        }
    }, [count]);

    const startCountUpTimer = () => {
        let intervalId = setInterval(() => {
            if (count < target) {
                count += step;
                setCount(count)
            } else {
                checkAndClearTimer();
            }
        }, randomTimeInMills());
        localStorage.setItem(operationKey(), intervalId + "");
    }

    const operationKey = () => {
        return CryptoUtils.SHA256(description).substring(0, 8);
    }

    const checkAndClearTimer = () => {
        clearInterval(parseInt(localStorage.getItem(operationKey()) as string));
    }

    useEffect(() => {
        if (canDispatch && count != target) {
            incrementUsersCount(count);
        }
    }, [count]);

    useEffect(() => {
        checkAndClearTimer()
        startCountUpTimer();
        return () => {
            checkAndClearTimer();
        }
    }, [description]);

    return (
        <div className={clsx(classes.root)} style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'center',
            alignContent: 'center',
            margin: 'auto'
        }}>
            {
                external ?
                    <InlineIcon icon={props.icon} width={40} height={40} style={{
                        color: AppColors.ACCENT_COLOR
                    }}/>
                    :
                    <IconButton
                        style={{color: AppColors.GREY_TEXT}}>{<props.icon style={{fontSize: 30}}/>}
                    </IconButton>
            }
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center'
                }}>
                <Typography
                    style={{color: AppColors.lightenOrDarken(AppColors.WHITE_SMOKE, 10), fontWeight: 600, fontSize: 25}}
                    dangerouslySetInnerHTML={{__html: `${NumberUtils.formatInThousands(parseFloat(count.toFixed(8)))}`}}/>
                <Typography style={{color: AppColors.lightenOrDarken(blueGrey[200], 20), fontWeight: 600, fontSize: 14}}
                            dangerouslySetInnerHTML={{__html: description}}/>
            </div>
        </div>
    );
}